<template>
  <div class="loginwrap">
    <div class="login-img">
      <!--<img src="../../assets/images/login-img.png">-->
    </div>
    <div class="login_carousel_wrap of">
      <el-carousel class="login_carousel" :interval="3000" height="55px" direction="vertical">
        <el-carousel-item>
          <img src="../../assets/images/img21.png" alt="">
        </el-carousel-item>
        <el-carousel-item>
          <img src="../../assets/images/img22.png" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="login">
      <el-form :model="logonForm" :rules="logonRules" ref="logonForm">
        <el-row>
          <el-col :span="24">
            <el-form-item prop="j_username">
              <el-input v-model="logonForm.j_username" placeholder="请输入用户名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="j_password">
              <el-input
                type="password"
                v-model="logonForm.j_password"
                @keyup.enter.native="onSubmit('logonForm')"
                placeholder="请输入密码"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item v-if="!scfcc" prop="j_captcha">
              <el-input v-model="logonForm.j_captcha" class="input-yzm"
                        @keyup.enter.native="onSubmit('logonForm')"
                        placeholder="请输入图形验证码"
              ></el-input>
              <img src="/verify.jpg" @click="$refs['captchaImg'].src='/verify.jpg?'+Math.random()" ref="captchaImg">
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item>
              <!--<el-checkbox v-model="logonForm.rem" true-label="on" false-label="" label="两周免登陆"
                           style="color:#fff"></el-checkbox>-->
              <el-checkbox v-model="logonForm.rememberUserName" style="color:#fff">记住用户名</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item>
              <el-button type="danger" @click="onSubmit('logonForm')" class="login-button">登录</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="login-foot">
      注意：建议在1920x1080及以上分辨率访问本系统。
    </div>
  </div>
</template>
<script>
  import xhr from '../../utils/xhr'

  export default {
    data() {
      return {
        scfcc: '',
        scfcu: '',
        logonForm: {
          j_merchant: '',
          j_username: '',
          j_password: '',
          j_captcha: '',
          rem: '',
          rememberUserName: true
        },
        logonRules: {
          j_username: [
            {
              required: true,
              message: '请输入用户名'
            },
            {
              min: 2,
              message: '用户名长度最少2位'
            }
          ],
          j_password: [
            {
              required: true,
              message: '请输入密码'
            }
          ],
          j_captcha: [
            {
              required: true,
              message: '请输入图形验证码'
            }
          ]
        }
      }
    },
    mounted: function () {
      this.logonForm.j_username = this.$cookie.get('j_username') || ''
      this.scfcc = this.$cookie.get('scfcc') || ''
      this.scfcu = this.$cookie.get('scfcu') || ''

      // this.scfcu && this.$router.push('/pages') //免登录
    },
    methods: {
      onSubmit: function (formName) {
        //记住用户名
        if (this.logonForm.rememberUserName) {
          this.$cookie.set('j_username', this.logonForm.j_username, { expires: '1Y' })
        }
        this.$refs[formName].validate(valid => {
          if (valid) {
            xhr.login(
              this.logonForm,
              res => {
                try {
                  if (res.data.status == 'success') {
                    this.$cookie.set('scfcc', res.data.scfcc || '', { expires: '1Y' })
                    this.$cookie.set('scfcu', res.data.scfcu || '', { expires: '1Y' })

                    this.getUserInfo()
                  }
                  else {
                    this.scfcc = ''
                    this.$alert(res.data.errmsg || '对不起，登录失败！')
                    this.$refs['captchaImg'].src = '/verify.jpg?' + Math.random()
                  }
                } catch (e) {
                  console.log(e)
                }
              }
            )
          }
          else {
            return false
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      getUserInfo: function () {
        xhr.getUserInfo({},res=>{
          try {
            if(res.data.status == 'success') {
              this.$store.commit('setUserInfo', res.data.data)
              this.$router.push({path:'/pages'})
            }
          }catch (e) {

          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/logon/LogonView.vue